/**
 * Created by Yunxuan Yan on 2017/10/11.
 */

import template from './preview.html';
import Component from "../../../lib/component";
import './preview.css';
import '../../../assets/scss/util/util.scss';
import {returnIframeUrl} from "../../../lib/http";

let preview_file = ["gif","jpg","jpeg","png","wmv","mp4"];

let Preview = Component.extend({
    template:template,
    data:{
        firstPreviewableIndex:0,
        lastPreviewableIndex:0,
        isFirst:false,
        isLast:false,
        record_type:'table'
    },
    binds:[
        {
            event: 'click',
            selector: '.closeImg',
            callback: function () {
                this.el.find('.my-mask').hide();
                this.data.dragStart = false;
                this.el.remove();
                // $(document).off("mousewheel DOMMouseScroll");
            }
        }, {
            event: 'mouseup',
            selector: '.img-pre',
            callback: function () {
                this.data.dragStart = false;
            }
        }, {
            event: 'mousemove',
            selector: '.img-pre',
            callback: function ($event) {
                //是否拖拽
                if (!this.data.dragStart) {
                    return;
                }

                //初始值调用 计算位移偏差值
                let disX = $event.clientX - this.data.dragStartX;
                let disY = $event.clientY - this.data.dragStartY;

                //计算图片相对位置
                let goX = this.data.imgStartX + disX + $(".img-pre").width() / 2;
                let goY = this.data.imgStartY + disY + $(".img-pre").height() / 2;

                $($event.target).css({'top': goY + 'px', 'left': goX + 'px'});
            }
        }, {
            event: 'mousedown',
            selector: '.img-pre',
            callback: function ($event) {
                $event.preventDefault && $event.preventDefault();//这个很重要
                //dragStart==可拖拽标识
                this.data.dragStart = true;

                //初始值记录
                this.data.dragStartX = $event.clientX;
                this.data.dragStartY = $event.clientY;
                this.data.imgStartX = this.el.find('.img-pre').position().left;
                this.data.imgStartY = this.el.find('.img-pre').position().top;
            }
        }, {
            event:'click',
            selector: '.save',
            callback:function (event) {
                this.el.find('.download-url').attr('href', returnIframeUrl(`/download_attachment/?file_id=${event.id}&download=1&dinput_type=${this.data.dinput_type}&record_type=${this.data.record_type}`));
            }
        }, {
            event: 'click',
            selector: '.zoom-out',
            callback: function () {
                this.data.imgScale -= 0.1;
                this.actions._updatePreview();
            }
        }, {
            event: 'click',
            selector: '.zoom-in',
            callback: function () {
                this.data.imgScale += 0.1;
                this.actions._updatePreview();
            }
        }, {
            event: 'click',
            selector: '.rotate',
            callback: function (event) {
                this.data.rotateNo -= 90;
                this.data.imgScale = 1;
                this.el.find(".img-pre").css({
                    "transform": "translate(-50%,-50%) rotate(" + this.data.rotateNo + "deg)",
                    "top": "50%",
                    "left": "50%"
                });
                this.actions._uploadScale();
            }
        }, {
            event: 'click',
            selector: '.rotate-anti',
            callback: function (event) {
                this.data.rotateNo += 90;
                this.data.imgScale = 1;
                this.el.find(".img-pre").css({
                    "transform": "translate(-50%,-50%) rotate(" + this.data.rotateNo + "deg)",
                    "top": "50%",
                    "left": "50%"
                });
                this.actions._uploadScale();
            }
        },
        {
            event:'click',
            selector: '.resize',
            callback:function () {
                this.data.imgScale = 1;
                this.data.rotateNo = 0;
                this.actions._updatePreview();
            }
        }, {
            event: 'click',
            selector:'.previous',
            callback:function () {
                this.actions._prePicture();
            }
        }, {
            event: 'click',
            selector:'.next',
            callback:function () {
                this.actions._nextPicture();
            }
        }
    ],
    actions:{
        _prePicture(){
            if(this.data.isFirst){
                return;
            }
            let fileId;
            if(this.data.list[0].file_id){//兼容附件浏览的情况
                //找到前一个可浏览的文件的索引
                let i = this.data.currentIndex - 1;
                for(;i >=0; i--){
                    if(!this.data.list[i].file_name){
                        break;
                    }
                    let type = this.data.list[i].file_name.split('.').pop();
                    if(preview_file.includes(type.toLowerCase())){
                        break;
                    }
                }
                if(i < 0){ //前面没有可浏览文件
                    this.data.firstPreviewableIndex = this.data.currentIndex;
                    this.actions._updateSwiftButtons(this.data.currentIndex);
                    return;
                } else {
                    this.data.currentIndex=i;
                }
                fileId = this.data.list[this.data.currentIndex].file_id;
            }else {//普通图片浏览
                this.data.currentIndex = this.data.currentIndex == 0? this.data.currentIndex:this.data.currentIndex - 1;
                fileId = Object.keys(this.data.list[this.data.currentIndex])[0];
            }
            this.actions._loadPreview(fileId,true);
            this.actions._checkPrevCanPreview(this.data.currentIndex-1);
        },
        _nextPicture(){
            if(this.data.isLast){
                return;
            }
            let fileId;
            if(this.data.list[0]['file_id']) {//兼容附件浏览的情况
                //找到前一个可浏览的文件的索引
                let i = this.data.currentIndex + 1;
                let length = this.data.list.length;
                for (; i < length; i++) {
                    if(!this.data.list[i].file_name){
                        break;
                    }
                    let type = this.data.list[i].file_name.split('.').pop();
                    if (preview_file.includes(type.toLowerCase())) {
                        break;
                    }
                }
                if (i >= length) { //后面没有可浏览文件
                    this.data.lastPreviewableIndex = this.data.currentIndex;
                    this.actions._updateSwiftButtons(this.data.currentIndex);
                    return;
                } else {
                    this.data.currentIndex=i;
                }
                fileId = this.data.list[this.data.currentIndex]['file_id'];
            } else {//普通图片浏览
                this.data.currentIndex = this.data.currentIndex < this.data.list.length - 1? this.data.currentIndex + 1:this.data.currentIndex;
                fileId = Object.keys(this.data.list[this.data.currentIndex])[0];
            }
            this.actions._loadPreview(fileId,true);
        },
        _uploadScale() {
            this.el.find('.scale').text(Math.floor(this.data.imgScale*100)+"%");
        },
        _updatePreview() {
            this.el.find(".img-pre").css('transform','translate(-50%,-50%) rotate(' + this.data.rotateNo + 'deg) scale(' + this.data.imgScale + ')');
            this.actions._uploadScale();
        },
        _loadPreview(id,checkPrev){
            this.el.find('.my-mask').show();
            this.data.rotateNo = 0;
            this.data.imgScale = 1;
            this.actions._uploadScale();
            this.actions._updateSwiftButtons(this.data.currentIndex);
            if(!checkPrev){
	            this.actions._checkPrevCanPreview(this.data.currentIndex-1);
            }
            this.el.find('.img-pre').css("max-height", $(window).height() * 0.8 + 'px');
            this.el.find('.img-pre').css('max-width',$(window).width() * 0.9 + 'px');
            this.el.find(".img-pre").css("transform", "translate(-50%,-50%) rotate(" + this.data.rotateNo + "deg) scale(" + this.data.imgScale + "," + this.data.imgScale + ")");
            this.el.find('.img-pre').get(0).src = returnIframeUrl(`/download_attachment/?file_id=${id}&download=0&dinput_type=${this.data.dinput_type}&record_type=${this.data.record_type}`);
            console.log('预览   ',this.el.find('.img-pre').get(0).src)
            this.el.on("wheel", '.img-pre',(e) => {
                let delta = e.originalEvent['wheelDelta']|| -(e.originalEvent['detail']);
                if (delta > 0) {
                    this.data.imgScale += 0.1;
                    this.actions._updatePreview();
                } else if (delta < 0) {
                    this.data.imgScale -= 0.1;
                    this.actions._updatePreview();
                }
            });
            this.el.find(".save").attr('id',id);
        },
        _getCurrentIndex(id){
            let i = 0;
            for(let length = this.data.list.length; i < length; i++){
                if(id == this.data.list[i]['file_id']) {
                    break;
                }
            }
            return i;
        },
        _updateSwiftButtons(i){
            if(i == this.data.firstPreviewableIndex){
                this.el.find('.previous').hide();
                this.data.isFirst = true;
            } else {
                this.el.find('.previous').show();
                this.data.isFirst = false;
            }
            if(i == this.data.lastPreviewableIndex){
                this.el.find('.next').hide();
                this.data.isLast = true;
            } else {
                this.el.find('.next').show();
                this.data.isLast = false;
            }
        },
	    _checkCanPreview(){
		    if(this.data.list[0].file_id) {//兼容附件浏览的情况
			    //找到前一个可浏览的文件的索引
			    let i = this.data.list.length - 1;
			    let index = 0;
			    for (; i >= 0; i--) {
				    if (!this.data.list[i].file_name) {
					    index++;
				    }
				    let type = this.data.list[i].file_name.split('.').pop();
				    if (preview_file.includes(type.toLowerCase())) {
					    index++;
				    }
			    }
			    if (index <= 1) { //前面没有可浏览文件
				    this.el.find('.next').hide();
				    this.el.find('.previous').hide();
			    }
		    }
	    },
	    _checkPrevCanPreview(i){
		    if(this.data.isFirst){
			    return;
		    }
		    if(this.data.list[0].file_id){//兼容附件浏览的情况
			    //找到前一个可浏览的文件的索引
			    for(;i >=0; i--){
				    if(!this.data.list[i].file_name){
					    break;
				    }
				    let type = this.data.list[i].file_name.split('.').pop();
				    if(preview_file.includes(type.toLowerCase())){
					    break;
				    }
			    }
			    if(i < 0){ //前面没有可浏览文件
				    let index= this.data.firstPreviewableIndex;
				    this.data.firstPreviewableIndex = this.data.currentIndex-1;
				    this.actions._updateSwiftButtons(this.data.currentIndex-1);
				    this.data.firstPreviewableIndex = index;
				    return;
			    }
		    }
	    },
	    _checkNextCanPreview(i){
		    if(this.data.isLast){
			    return;
		    }
		    if(this.data.list[0]['file_id']) {//兼容附件浏览的情况
			    //找到前一个可浏览的文件的索引
			    let length = this.data.list.length;
			    for (; i < length; i++) {
				    if(!this.data.list[i].file_name){
					    break;
				    }
				    let type = this.data.list[i].file_name.split('.').pop();
				    if (preview_file.includes(type.toLowerCase())) {
					    break;
				    }
			    }
			    if (i >= length) { //后面没有可浏览文件
				    let index = this.data.lastPreviewableIndex
				    this.data.lastPreviewableIndex = this.data.currentIndex+1;
				    this.actions._updateSwiftButtons(this.data.currentIndex+1);
				    this.data.lastPreviewableIndex=index;
				    return;
			    }
		    }
	    }
    },
    afterRender:function () {
        this.data.lastPreviewableIndex = this.data.list.length - 1;
        if(this.data.currentIndex == undefined){
             this.data.currentIndex = this.actions._getCurrentIndex(this.data.id);
        } else {
            this.data.id = Object.keys(this.data.list[this.data.currentIndex])[0];
        }
        this.actions._loadPreview(this.data.id);
        this.actions._checkCanPreview();
    },
    firstAfterRender: function() {
        let _this = this;
	    window.focus();
        $(document).keyup(function (e) {
            if (e.keyCode === 39) {
                _this.actions._nextPicture();
            }

            if (e.keyCode === 37) {
                _this.actions._prePicture();
            }

            if (e.keyCode === 27) {
                _this.el.find('.preview').hide();
                _this.data.dragStart = false;
                _this.el.remove();
            }

            if (e.keyCode === 107) {
                _this.data.imgScale += 0.1;
                _this.actions._updatePreview();
            }

            if (e.keyCode === 109) {
                _this.data.imgScale -= 0.1;
                _this.actions._updatePreview();
            }
        })
    },

    beforeDestroy() {
        $(document).keyup(function () {
            return false;
        })
    }
});

export default Preview;



// WEBPACK FOOTER //
// app/components/util/preview/preview.js